import type { MouseEventHandler } from 'react';
import { forwardRef, memo } from 'react';

import type { InputProps } from '../Input/index.tsx';
import { Input } from '../Input/index.tsx';
import { ClearIcon, ClearableInputContainer, IconButton } from './styles.ts';

interface DatePickerInputProps extends Omit<InputProps, 'ref'> {
  isClearable?: boolean;
  onClearClick?: MouseEventHandler<HTMLButtonElement>;
  dateSelected?: boolean;
}

const DatePickerInput = forwardRef<HTMLInputElement, DatePickerInputProps>(function DatePickerInput(
  { onClearClick, isClearable, dateSelected, ...restProps },
  ref,
) {
  if (isClearable) {
    return (
      <ClearableInputContainer>
        <Input ref={ref} {...restProps} clearButton />
        {dateSelected && (
          <IconButton onClick={onClearClick}>
            <ClearIcon size={10} />
          </IconButton>
        )}
      </ClearableInputContainer>
    );
  }

  return <Input {...restProps} />;
});

export default memo(DatePickerInput);
